import {isDuApp} from '../appUtils/getDevice'
import {TrackShareChannelMap} from '@/constant'
export default function getQuery(query: string) {
  try {
    return new URLSearchParams(window.location.search).get(query)
  } catch{
    return null
  }
}

export const poizonChannelID = isDuApp() ? TrackShareChannelMap.页面在app内部 : getQuery('shareChannel')
